import { Colors } from '@oy/uicore';
import { Spacer } from '@oy/uidesktop';
import { SystemIcon } from '@oy/uiicon';
import { useMemo } from 'react';
import { IS_DANARAPAY } from 'src/constants';
import { useEnv } from 'src/hooks';
import { useSidebarState } from '../hooks';
import styles from './Sidebar.module.css';

const SidebarLogo = () => {
  const { isProdEnv } = useEnv();
  const { toggleSidebar, isSidebarOpen, isSidebarCollapsed } =
    useSidebarState();

  const collapsedImage = useMemo(() => {
    if (IS_DANARAPAY) {
      return `/icons/${
        isProdEnv ? 'danarapay-icon-white' : 'danarapay-icon'
      }.svg`;
    }
    return `/icons/${isProdEnv ? 'oy-icon-white' : 'oy-icon'}.svg`;
  }, [isProdEnv]);
  const expandedImage = useMemo(() => {
    if (IS_DANARAPAY) {
      return `/img/${
        isProdEnv ? 'danarapay-main-logo-white' : 'danarapay-main-logo'
      }.svg`;
    }
    return `/img/${isProdEnv ? 'main-logo-white' : 'main-logo'}.png`;
  }, [isProdEnv]);
  const imageSrc = isSidebarCollapsed ? collapsedImage : expandedImage;
  const height = IS_DANARAPAY ? 24 : 20;
  return (
    <Spacer bottom={Spacer.Size.M} className={styles.logoSection}>
      <img
        //? Force re-render the img element by passing key
        key={imageSrc}
        src={imageSrc}
        alt={`${import.meta.env.VITE_BRAND_NAME} Logo`}
        height={isSidebarCollapsed ? 24 : height}
      />
      <span
        role="button"
        title={isSidebarOpen ? 'Collapse' : 'Pin'}
        onClick={toggleSidebar}
        className={styles.collapseButton}
      >
        {isSidebarOpen ? (
          <SystemIcon
            name="collapse"
            size={20}
            color={isProdEnv ? Colors.WHITE : Colors.BLACK100}
          />
        ) : (
          <SystemIcon name="arrow-right" size={13.5} color={Colors.WHITE} />
        )}
      </span>
    </Spacer>
  );
};

export default SidebarLogo;
